/**
 * Export `contacts`.
 */

export const contacts = {
  address: 'Estrada Nacional 206, KM38\n4805-026 Brito, Guimarães\nPortugal',
  email: 'aa-pt-sales@wthg.com',
  emailHR: 'aa-pt-rh-geral@wthg.com',
  fax: '+351 253 531 527',
  gpsCoordinates: {
    latitude: '41.4465',
    longitude: '-8.35703'
  },
  phone: '+351 253 540 200',
  whatsapp: '+351 938 131 591'
};
